import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import { Table } from 'antd'
const { WizSpin, WizButton, WizCard, WizModal } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool
import moment from 'moment'

import CounselingHeader from '../../header'

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/review/notification') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('reviewNotification', record)
        } else {
            record = Session.get('reviewNotification') || {}
        }
    }
    return record
}

class ReviewNotification extends WizContainer {

    componentName = 'ReviewNotification'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record
        }
    }

    _componentDidMount() {
        this._list()
    }

    _list = () => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/preAuditOrCheckInfo',
            payload: {
                key: 'reviewNotification@' + processContentId,
                apiParams: {
                    processId: processContentId,
                    type: 2
                }
            }
        })
    }

    _onBtn = (type, id) => {
        const { processContentId } = this.state.record
        let path
        switch (type) {
            case 'look':
                path = '/integrationCounseling/manager/review/lookNotification'
                break
            case 'send':
                path = '/integrationCounseling/manager/review/sendNotification'
                break
        }
        this.jumpPage('push', path, { processContentId, recordId: id })
    }

    _Abandoned = (id) => {
        WizModal.confirm({
            title: '注意',
            content: '是否确认进行作废操作？',
            onOk: () => {
                this.doAction({
                    path: 'counselingProcess/updateAuditCheckState',
                    payload: {
                        key: 'counselingProcess@counselingProcess',
                        apiParams: {
                            id: id,
                            type: 2,
                            state: 4
                        }
                    }
                })
            },
            onCancel() {
            }
        })
    }

    _onConfirm = () => {
        const { processContentId } = this.state.record
        WizModal.confirm({
            title: '注意',
            content: '是否确认进行达标确认操作？',
            onOk: () => {
                this.doAction({
                    path: 'counselingProcess/confirmPreAuditOrCheck',
                    payload: {
                        key: 'confirmReviewNotification@' + processContentId,
                        apiParams: {
                            processId: processContentId,
                            type: 2
                        }
                    }
                })
            },
            onCancel() {
            }
        })
    }

    propsAndStateOnChange = {
        confirm: this._confirmOnChange.bind(this),
        updateAuditCheckState : this._updateAuditCheckState.bind(this)
    }

    _confirmOnChange(nextProps, nextState) {
        if (nextProps.confirm.code === 1) {
            wizNotice.success('操作成功')
            this.jumpPage('goBack')
        } else {
            wizNotice.error(nextProps.confirm.msg)
        }
    }

    _updateAuditCheckState(nextProps, nextState) {
        if (nextProps.updateAuditCheckState.code === 1) {
            wizNotice.success('操作成功')
            this._list()
        } else {
            wizNotice.error(nextProps.updateAuditCheckState.msg)
        }
    }

    render() {
        let { record } = this.state
        let { list, counselingProcessLoading } = this.props
        let data = list.data || []
        let columns = [{
            title: '执行内容',
            name: 'processName',
            dataIndex: 'processName',
        }, {
            title: '通知时间',
            name: 'noticeTime',
            dataIndex: 'noticeTime',
            render: (v) => v ? moment(v).format('YYYY-MM-DD HH:mm') : ''
        }, {
            title: '签收时间',
            name: 'completeTime',
            dataIndex: 'completeTime',
            render: (v) => v ? moment(v).format('YYYY-MM-DD HH:mm') : ''
        }, {
            title: '状态',
            name: 'state',
            dataIndex: 'state',
            render: (v) => {
                switch (v) {
                    case 1:
                        return '待下发'
                    case 2:
                        return '待签收'
                    case 3:
                        return '已签收'
                    case 4:
                        return '已作废'    
                    default:
                        return ''
                }
            }
        }, {
            title: '操作',
            name: 'operation',
            dataIndex: 'operation',
            align: 'center',
            width: 220,
            render: (v, r, i) => {
                let { id, state } = r
                return (
                    <WizButton.Group>
                        <WizButton type='link' disabled={state === 1} onClick={() => this._onBtn('look', id)}>
                            {'查看'}
                        </WizButton>
                        <WizButton type='link' 
                        disabled={state != 2 } 
                        onClick={() => this._Abandoned(id)}>
                            {'作废'}
                        </WizButton>
                    </WizButton.Group>
                )
            }
        }]

        let tableProps = {
            columns,
            dataSource: data,
            pagination: false,
            bordered: true
        }

        return (
            <WizSpin spinning={counselingProcessLoading} >
                <CounselingHeader record={record} />
                <WizCard title='检核通知'>
                    <WizButton
                        type='primary'
                        style={{ marginBottom: 15, width: 120 }}
                        onClick={() => this._onBtn('send')}>
                        {'下发检核通知'}
                    </WizButton>
                    <Table {...tableProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { processContentId } = findParamRecord(ownProps.history)
    const list = modelUtils.getModelEntity(counselingProcess, 'reviewNotification@' + processContentId)
    const confirm = modelUtils.getModelEntity(counselingProcess, 'confirmReviewNotification@' + processContentId)
    const updateAuditCheckState = modelUtils.getModelEntity(counselingProcess, 'counselingProcess@counselingProcess')
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        list,
        confirm,
        updateAuditCheckState,
        ...loading
    }
}

export default connect(mapStateToProps)(ReviewNotification)

